import React, { useCallback, useEffect } from 'react';
import { Checkbox, Grid, TextField, Typography } from '@mui/material';
import {
    CheckCircle as CircleChecked,
    RadioButtonUnchecked as CircleUnchecked,
} from '@mui/icons-material';
import { partial, times } from 'lodash';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import PropTypes from 'prop-types';
import { limitWordsAndSpaces } from '../utils/limitWordsAndSpaces';

export default function TaskRadioOptionBlock({
    path = [''],
    fieldName = 'text'
}) {
    useEffect(() => {
        console.assert(!!path, 'No path specified!');
    }, [path]);

    const [array] = useTaskField(path);

    return (
        <Grid container spacing={2} style={{ flexDirection: 'column' }}>
            {times(array?.length, index => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <Item parent={path} index={index} fieldName={fieldName} />
                </Grid>
            ))}
        </Grid>
    );
}
TaskRadioOptionBlock.propTypes =  {
  path: PropTypes.array.isRequired,
  fieldName: PropTypes.string
}

function onAnswerChange(setValue, maxWords) {
    return (event) => {
      const value = limitWordsAndSpaces(event.target.value, maxWords);
      setValue(value);
    };
  }

function Item({ parent, index, fieldName = 'text' }) {
    const useField = partial(useTaskField, parent, index);

    const [, setItems] = useTaskField(parent);

    const [text, setText, textError] = useField(fieldName);

    const onTextChange = onAnswerChange(setText, 12);

    const [isCorrect] = useField('is_correct_answer');

    const setAsCorrect = useCallback(() => {
        setItems(prev => prev.map((a, i) => ({
            ...a,
            is_correct_answer: i === index,
        })));
    }, [index, setItems]);

    const letterId = String.fromCharCode('A'.charCodeAt(0) + index);

  const onPaste = useCallback((event) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text').trim();
    const newValue = text ? text + ' ' + pastedData : pastedData;
    const filteredValue = limitWordsAndSpaces(newValue, 12);
    setText(filteredValue);
  }, [text, setText]);

    return (
        <div style={{ display:'flex', alignItems:'flex-start' }}>
            <Checkbox
                checked={isCorrect}
                onClick={setAsCorrect}
                icon={<CircleUnchecked />}
                checkedIcon={<CircleChecked />}
                color='primary'
                style={{ alignItems:'flex-start' }}
            />
        <div style={{ paddingTop: '8px' }}>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom:'4px' }}>{`Option ${letterId}`}</Typography>
          <TextField
            fullWidth
            value={text}
            variant='filled'
            onChange={onTextChange}
            onPaste={onPaste}
            error={!!textError}
            helperText={textError ?? 'Select if key'}
            sx={{ width:'609px', '& .MuiInputBase-input' : { width: '609px' }}}
          />
        </div>
        </div>
    );
}
Item.propTypes = {
  parent: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  fieldName: PropTypes.string
}